import React, { useState, useContext, useCallback } from 'react'
import { AuthContext } from '@/layout/Auth'
import { BasicCard, Icon } from './components'
import InfoCard from './info'
import FormCard from './form'
import StatusCard from './status'
import { checkVerification } from '@/api'
import { useQuery } from '@tanstack/react-query'

const Verification: React.FC<unknown> = () => {
  const [edit, setEdit] = useState<boolean>(false)
  const { updateAuthInfo } = useContext(AuthContext)
  const { data } = useQuery(['checkVerification', edit], checkVerification, {
    refetchOnMount: true,
    onSuccess: (result) => {
      if (result.certify_status === 1) {
        updateAuthInfo({ verified: true })
      }
    },
  })

  const changeEdit = useCallback(
    (editState: boolean) => () => {
      setEdit(editState)
    },
    []
  )

  return (
    <BasicCard view={edit ? 'form' : 'info'} sx={{ alignItems: 'center' }}>
      {edit ? (
        <FormCard info={data} onClose={changeEdit(false)} />
      ) : (
        <>
          <Icon sx={{ alignSelf: 'flex-start', width: '100px' }} />
          {data?.certify_status === 1 || data?.certify_status === 2 ? (
            <StatusCard info={data} onClick={changeEdit(true)} />
          ) : (
            <InfoCard onClick={changeEdit(true)} />
          )}
        </>
      )}
    </BasicCard>
  )
}

export default Verification
